export const PAGE_SECTIONS = [
  { value: "info", label: "Info", allowsHome: false },
  { value: "rankings", label: "Rankings", allowsHome: false },
  { value: "data-products", label: "Data products", allowsHome: true },
] as const;

export type PageSection = (typeof PAGE_SECTIONS)[number]["value"];

export const DEFAULT_PAGE_SECTION: PageSection = "info";

export function isPageSection(value: unknown): value is PageSection {
  return PAGE_SECTIONS.some(section => section.value === value);
}

export function pageSectionOf(page: { section?: string | null }): PageSection {
  return isPageSection(page.section) ? page.section : DEFAULT_PAGE_SECTION;
}

export function pageSectionLabel(section: PageSection): string {
  return PAGE_SECTIONS.find(option => option.value === section)?.label ?? section;
}

export function sectionAllowsHome(section: PageSection): boolean {
  return PAGE_SECTIONS.find(option => option.value === section)?.allowsHome ?? false;
}
